"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnonymousStorageList = useAnonymousStorageList;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useAnonymousClient_1 = require("./useAnonymousClient");
/**
 * Calls `anonymousClient.storageList` and returns an SWR response. SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param entity - entity name
 * @param request - request to pass to `anonymousClient.storageList`, this is optional, if not set backend will not be called and result will not be returned
 * @param appName - optional appName, if not set `window.appName` will be used
 * @param config - custom SWR configuration object, can be used to remove the custom `laggy` middleware
 */
function useAnonymousStorageList(entity, request, appName, config) {
    const resolvedAppName = (0, utils_1.getAppName)(appName);
    const storage = (0, useAnonymousClient_1.useAnonymousClient)(resolvedAppName, entity);
    return (0, swr_1.default)(request ? [`/platform/anonymous/storage/${entity}/list`, request] : null, async ([, request]) => {
        return request ? storage.storageList(request) : undefined;
    }, config ?? {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
}
